import { useEffect } from 'react';
import { Row, Col } from 'antd';

const Title = (props) => {
  const { actions } = props;

  useEffect(() => {
    document.title = props.children + " - PTPP";
  }, []);

  if (actions) {
    return (
      <Row className="gx-mb-2">
        <Col span={12}>
          <h1 className="title gx-mb-4">{props.children}</h1>
        </Col>
        <Col span={12} className="gx-text-right">
          {actions}
        </Col>
      </Row>
    );
  }

  return (
    <h1 className="title gx-mb-4">{props.children}</h1>
  );
}

export default Title;